import React from 'react';
import { Formik } from 'formik';
import { compose } from 'redux';
import withStyles from '@material-ui/styles/withStyles';
import { Grid, Drawer, Button } from '@material-ui/core';
import ActivityLogDrawerHeader from 'features/wells/overview/activityLog/drawer/ActivityLogDrawerHeader';
import ActivityLogFormFields from 'features/wells/overview/activityLog/drawer/ActivityLogFormFields';
import { getActivityLogFormSchema } from 'features/wells/overview/activityLog/helpers/activityLog.validators';
import { ACTIVITY_LOG_FORM_FEILDS } from 'features/wells/overview/activityLog/helpers/activityLog.constants';

const ActivityLogDrawer = ({
  classes,
  isOpen,
  toggleDrawer,
  responsibleUsers,
  initialActivityLogFormValues,
  upsertActivityLog,
  resetActivityFormValues,
}) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={() => {
        toggleDrawer();
        resetActivityFormValues();
      }}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Formik
        enableReinitialize
        onSubmit={(values) => upsertActivityLog(values)}
        initialValues={initialActivityLogFormValues ?? {}}
        validationSchema={getActivityLogFormSchema()}
      >
        {({ handleSubmit, dirty, isValid, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Grid item className={classes.mainContainer}>
              <Grid className={classes.drawerHeader}>
                <ActivityLogDrawerHeader
                  toggleDrawer={toggleDrawer}
                  title={
                    initialActivityLogFormValues[
                      ACTIVITY_LOG_FORM_FEILDS.ACTIVITY_LOG_ID
                    ]
                      ? 'Edit Activity'
                      : 'Add Activity'
                  }
                />
              </Grid>
              <Grid item className={classes.sectionContainer}>
                <Grid container className={classes.addLogForm}>
                  <ActivityLogFormFields responsibleUsers={responsibleUsers} />
                </Grid>
              </Grid>
              <Grid item className={classes.drawerFooter}>
                <Button
                  title="Cancel"
                  color="secondary"
                  variant="text"
                  type="button"
                  className={classes.drawerButton}
                  onClick={() => {
                    toggleDrawer();
                    resetActivityFormValues();
                  }}
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  title="Save"
                  color="primary"
                  variant="contained"
                  type="submit"
                  className={classes.drawerButton}
                  size="large"
                  disabled={isSubmitting || !isValid || !dirty}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Drawer>
  );
};

const styles = (theme) => ({
  drawerPaper: {
    width: '30%',
    minWidth: 300,
    background: theme.palette.background.default,
  },
  drawerHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: `2px solid ${theme.palette.table.row.hover}`,
  },
  drawerContent: {
    overflowY: 'scroll-y',
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
  },
  sectionContainer: {
    padding: theme.spacing(2),
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  drawerFooter: {
    position: 'fixed',
    bottom: 0,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    right: 0,
    backgroundColor: theme.palette.secondary.dark,
    width: '30%',
  },
  drawerButton: {
    margin: theme.spacing(2),
    color: theme.palette.common.white,
  },
  addLogForm: {
    display: 'flex',
    alignItems: 'left',
    marginTop: theme.spacing(2),
  },
});

export default compose(withStyles(styles))(ActivityLogDrawer);
